export default "__VITE_ASSET__ebfd893b__"